import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ActiveLink from './ActiveLink'

@inject("store")
@observer
export default class TagViewer extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }

  handleTagSelection = (tag) => {
    const { store } = this.props
    store.activeTag = tag
  }

  render() {
    const { store, buttonBackgroundColor, buttonForegroundColor, textColor } = this.props
    const { designCategoryTags, activeTag } = store
    const { primaryColor, contrastColor } = store.franchise.attributes

    const activeStyle = {
      backgroundColor: buttonBackgroundColor || primaryColor,
      color: buttonForegroundColor || contrastColor,
      ...styles.tag
    }
    const inactiveStyle = {
      backgroundColor: buttonForegroundColor || contrastColor,
      color: buttonBackgroundColor || primaryColor,
      ...styles.tag
    }

    return (
      <div style={styles.wrapper}>
        <div style={styles.container}>
          <ActiveLink
            show={!!activeTag}
            onClick={() => this.handleTagSelection(null)}
            activeStyle={activeStyle}
            inactiveStyle={inactiveStyle}
          >
            All Categories
          </ActiveLink>
        </div>
        { designCategoryTags.map(tag =>
          <div key={tag.id} style={styles.container}>
            <ActiveLink
              show={activeTag !== tag}
              onClick={() => this.handleTagSelection(tag)}
              activeStyle={activeStyle}
              inactiveStyle={inactiveStyle}
            >
              { tag.attributes.name }
            </ActiveLink>
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10
  },
  container: {
    padding: "2px 10px",
    marginBottom: 25
  },
  tag: {
    padding: 10,
    textDecoration: "none"
  }
}
